// Key Codes
export const ENTER_KEY_CODE = 13;
export const TAB_KEY_CODE = 9;
export const ESCAPE_KEY_CODE = 27;

export const DEFAULT_LANGUAGE = "en"; // English

export const MAX_BARRACKS_ENTRIES = 30;
export const MAX_BARRACKS_TROOP_COUNT = 50;
export const MIN_LEVEL_FOR_STARS = 15;
export const MAX_LEVEL_FOR_STARS = 16;

export const APP_TABS = {
  BARRACKS: "barracks",
  FORMATION: "formation",
  SETTINGS: "settings",
  STATS: "statistics",
};

export const APP_VIEWS = {
  CARD: "card",
  GAME: "game",
};

export const ITEM_TYPES = {
  HERO: "HERO",
  TROOP: "TROOP",
};

export const TROOP_SOURCES = {
  BARRACKS: "barracks",
  DATA: "data",
};
